<header>
  <h1 class="title">{{ title }}</h1>
  <button mat-button class="back" (click)="close()">戻る</button>
</header>
